export default __webpack_public_path__ + "static/media/ls.bfda25f0.svg";